var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-range--multi", attrs: { id: _vm.id } },
    [
      _c(
        "FieldItem",
        {
          staticClass: "common-range",
          attrs: { label: _vm.$t("Search.labels.subjectNucLength") },
        },
        [
          _c("div", { staticClass: "common-range-group" }, [
            _c("div", { staticClass: "common-range-group__input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue.nucleotide[0],
                    expression: "fieldValue.nucleotide[0]",
                  },
                ],
                staticStyle: { "text-align": "right" },
                attrs: { maxlength: 9, type: "text" },
                domProps: { value: _vm.fieldValue.nucleotide[0] },
                on: {
                  keypress: function ($event) {
                    return _vm.isNumber($event)
                  },
                  blur: _vm.syncChange,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.fieldValue.nucleotide, 0, $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "common-range-group__separator" }),
            _c("div", { staticClass: "common-range-group__input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue.nucleotide[1],
                    expression: "fieldValue.nucleotide[1]",
                  },
                ],
                staticStyle: { "text-align": "left" },
                attrs: { maxlength: 9, placeholder: "∞", type: "text" },
                domProps: { value: _vm.fieldValue.nucleotide[1] },
                on: {
                  keypress: function ($event) {
                    return _vm.isNumber($event)
                  },
                  blur: _vm.syncChange,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.fieldValue.nucleotide, 1, $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]
      ),
      _c(
        "FieldItem",
        {
          staticClass: "common-range",
          attrs: { label: _vm.$t("Search.labels.subjectProteinLength") },
        },
        [
          _c("div", { staticClass: "common-range-group" }, [
            _c("div", { staticClass: "common-range-group__input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue.protein[0],
                    expression: "fieldValue.protein[0]",
                  },
                ],
                staticStyle: { "text-align": "right" },
                attrs: { maxlength: 9, type: "text" },
                domProps: { value: _vm.fieldValue.protein[0] },
                on: {
                  keypress: function ($event) {
                    return _vm.isNumber($event)
                  },
                  blur: _vm.syncChange,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.fieldValue.protein, 0, $event.target.value)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "common-range-group__separator" }),
            _c("div", { staticClass: "common-range-group__input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue.protein[1],
                    expression: "fieldValue.protein[1]",
                  },
                ],
                staticStyle: { "text-align": "left" },
                attrs: { maxlength: 9, placeholder: "∞", type: "text" },
                domProps: { value: _vm.fieldValue.protein[1] },
                on: {
                  keypress: function ($event) {
                    return _vm.isNumber($event)
                  },
                  blur: _vm.syncChange,
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.fieldValue.protein, 1, $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }